import { render, staticRenderFns } from "./TabbedView.vue?vue&type=template&id=0baf6d0a&scoped=true"
import script from "./TabbedView.vue?vue&type=script&lang=js"
export * from "./TabbedView.vue?vue&type=script&lang=js"
import style0 from "./TabbedView.vue?vue&type=style&index=0&id=0baf6d0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baf6d0a",
  null
  
)

export default component.exports